import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import TestimonialsSection from './components/TestimonialsSection';
import ArticlesSection from './components/ArticlesSection';
import PartnersSection from './components/PartnersCTASection';
import { CTASection } from './components/PartnersCTASection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <FeaturesSection />
        <CategoriesSection />
        <TestimonialsSection />
        <ArticlesSection />
        <PartnersSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}